import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';

export const ImageGalleryComponent = ({ imageList }) => {
  return (
    <Row>
      {imageList.map((image, index) => {
        return (
          <Col xs={12} md={4} key={index} className="py-2 p-md-2">
            <Image src={image.src} alt={image.alt} fluid />
          </Col>
        );
      })}
    </Row>
  );
};
